import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'

export default class Button {
  constructor(data, object) {
    this.name = data.name.split('-')[0]
    this.payload = data.name.split('-')[1]
    this.id = `BUTTON:${this.name}`

    KeyboardManager.register({ id: this.id, payload: this.payload, tap: this.tap.bind(this) })
    enableTap(object, this.tap.bind(this))

    return object
  }

  tap() {
    ButtonManager.dispatch(this.id, this.payload)
  }
}
